import { PlatformLocation } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import ProjectIndex from '@assets/index';
import { environment } from '@environments/environment';
import { IProjectSettings } from '@models/ProjectSettings';


@Injectable({
    providedIn: 'root'
})
export class ProjectService {

    private settings: IProjectSettings;

    static get PROJECTS(): string[] {

        return Object.keys(ProjectIndex) || [];
    }

    constructor(private HttpClient: HttpClient) {

    }

    public async Init(): Promise<IProjectSettings> {

        if (this.settings) {
            const pathVersion = "assets/version.json?cache=" + new Date().getTime();

            const version = await fetch(pathVersion).then(response => response?.json()).catch(e => null);
            this.settings = this.mergeCommonDeep(this.settings, version);

            return Promise.resolve(this.settings);
        }

        const pathProd = this.GetProjectPath() + "/config.json?cache=" + new Date().getTime();
        const pathDev = this.GetProjectPath() + "/config.dev.json?cache=" + new Date().getTime();

        this.settings = await this.mergeCommonProperties(pathProd, pathDev);

        return this.settings;
    }

    /**
     * Faz merge de dois objetos apenas nas propriedades em comum.
     * @param pathProd Primeiro objeto
     * @param pathDev Segundo objeto
     * @returns Novo objeto com as propriedades em comum
     */
    private async mergeCommonProperties<T extends object, U extends object>(pathProd: string, pathDev: string): Promise<IProjectSettings> {

        const pathVersion = "assets/version.json?cache=" + new Date().getTime();

        const version = await fetch(pathVersion).then(response => response?.json()).catch(e => null);

        const base = await fetch(pathProd).then(response => response?.json()).catch(e => null);
        const updates = !environment.ConfigIsProduction ? await fetch(pathDev).then(response => response?.json()).catch(e => null) : await Promise.resolve(null);

        const result: any = this.mergeCommonDeep(base, version);
        const resultFinal: any = this.mergeCommonDeep(result, updates);

        console.log(resultFinal);

        return resultFinal;
    }

    /**
     * 
     * @param base 
     * @param updates 
     * @returns 
     */
    private mergeCommonDeep<T>(base: T, updates: Partial<T> = {}): T {
        const result: any = Array.isArray(base) ? [...base] : { ...base };

        const isObject = (value) => {
            return value !== null && typeof value === 'object' && !Array.isArray(value);
        }

        for (const key in updates) {
            if (base.hasOwnProperty(key)) {
                const baseValue = (base as any)[key];
                const updateValue = (updates as any)[key];

                // Se ambos forem objetos, aplica merge recursivamente
                if (isObject(baseValue) && isObject(updateValue)) {
                    result[key] = this.mergeCommonDeep(baseValue, updateValue);
                } else {
                    // Se não forem objetos, substitui o valor
                    result[key] = updateValue;
                }
            }
        }

        return result;
    }

    /**
     * 
     * @returns 
     */
    public GetGlobal() {
        return { IdEntity: this.settings?.Project?.Id || '' };
    }

    /**
     * devolve nome de projeto
     * @returns 
     */
    async GetProjectConfig(idEntity: string): Promise<IProjectSettings> {

        console.log("PROJECTS -------------->", ProjectService.PROJECTS);

        if (!idEntity) return;

        const config = (Object.values(ProjectIndex) || [])?.find(it => (it?.Id?.find(i => i.toLowerCase() == idEntity?.toLowerCase()))) || null;

        console.log(config);

        if (!config?.Folder) return;

        const pathProd = "assets/projects/" + config?.Folder + "/config.json?cache=" + new Date().getTime();
        const pathDev = "assets/projects/" + config?.Folder + "/config.dev.json?cache=" + new Date().getTime();

        this.settings = await this.mergeCommonProperties(pathProd, pathDev);

        return this.settings;
    }

    /**
     * atribui path do projeto
     * @param assetsPath 
     * @returns 
     */
    public GetProjectPath(assetsPath: "/images" | "/docs" | "" = ""): string {

        let basepath = "assets/projects/";

        // console.log(assetsPath);

        switch (window.location.hostname) {
            case ProjectIndex["boldapps"].Domain:               basepath = basepath + "boldapps"; break;
            case ProjectIndex["vianacastelo"].Domain:           basepath = basepath + "vianacastelo"; break;
            case ProjectIndex["funchal"].Domain:                basepath = basepath + "funchal"; break;
            case ProjectIndex["fornosalgodres"].Domain[0]:
            case ProjectIndex["fornosalgodres"].Domain[1]:      basepath = basepath + "fornosalgodres"; break;
            case ProjectIndex["santarem"].Domain:               basepath = basepath + "santarem"; break;
            case ProjectIndex["soure"].Domain:                  basepath = basepath + "soure"; break;
            case ProjectIndex["alvaiazere"].Domain:             basepath = basepath + "alvaiazere"; break;
            case ProjectIndex["almada"].Domain:                 basepath = basepath + "almada"; break;
            case ProjectIndex["matosinhos"].Domain:             basepath = basepath + "matosinhos"; break;
            case "demo.admin.smartcardcitizen.boldapps.pt":     basepath = basepath + "boldapps"; break;
            case "localhost":                                   basepath = basepath + (environment?.DebugProject != "" ? environment.DebugProject : "localhost"); break;
        }

        return basepath + assetsPath;
    }

    public GetSettings(): IProjectSettings {
        // console.log(this.settings);
        return this.settings;
    }

}
